import React from 'react';
import styleService from '@nykaa/deals-utils/styles';
import styled from '../../../theme';
const { getPaddingStyles, getMarginStyles, getFontStyles, getBKGStyles, setVisibility, getBorderStyles, getIndividualBorderRadius, } = styleService.utils;
export const HighlightsStyled = styled.ul `
  ${({ bkg }) => getBKGStyles(bkg)};
  ${({ margin }) => getMarginStyles(margin)};
  ${({ padding }) => getPaddingStyles(padding)};
  ${({ text }) => getFontStyles(text)};
  line-height: ${({ text }) => { var _a; return `${(_a = text === null || text === void 0 ? void 0 : text.lineHeight) === null || _a === void 0 ? void 0 : _a.web} !important`; }};
  ${({ visible, isHighlight, ishighlights, visibility, }) => {
    if (isHighlight && visible && !ishighlights) {
        return 'visibility: hidden';
    }
    return visibility && setVisibility(visible);
}};
  list-style-type: none;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: row;
  justify-content: center;
  white-space: nowrap;
  flex: 2;
  li {
    display: inline-flex;
    white-space: nowrap;
  }
  li:after {
    content: " ";
    letter-spacing: 1em;
    background: center center no-repeat
      url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwAAADsABataJCQAAABl0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC4xMkMEa+wAAAAnSURBVBhXY/Dz89MA4sNA/B9Ka4AEYQIwfBgkiCwAxjhVopnppwEApxQqhnyQ+VkAAAAASUVORK5CYII=);
  }
  ${({ individualCornerRadius }) => individualCornerRadius && getIndividualBorderRadius(individualCornerRadius)};
  ${({ position }) => (position === 'top'
    ? `border-bottom-left-radius: 0px;
       border-bottom-right-radius: 0px;`
    : `border-top-left-radius: 0px;
       border-top-right-radius: 0px;`)};
  ${({ position, borders }) => (position === 'top'
    && borders && `${getBorderStyles(borders)};
    border-bottom : 0px;`)};
  .highlight-image {
    display: inline-block;
    width: ${({ text }) => `${text.size.web}`};
    height: ${({ text }) => `${text.lineHeight.web}`};
    mask-image: ${({ highlightImage }) => `url(${highlightImage})`};
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: ${({ text }) => `${text.size.web} ${text.size.web}`};
    background-color: ${({ text }) => text === null || text === void 0 ? void 0 : text.color};
  }
`;
const Highlights = ({ style, highlights, isHighlight, position, hightlightImage, isDesktop, visibility, }) => (isHighlight && !!highlights[0]
    && (React.createElement(HighlightsStyled, Object.assign({}, style, { isHighlight: isHighlight, ishighlights: !!highlights[0], position: position, highlightImage: hightlightImage, isDesktop: isDesktop, visibility: visibility }), highlights.map((highlight) => (React.createElement("li", { key: highlight },
        hightlightImage && React.createElement("div", { className: "highlight-image" }),
        React.createElement("span", null, (highlight))))))));
export default Highlights;
